/* import __COLOCATED_TEMPLATE__ from './subscription-builder-modal.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { ModalTypes } from './subscription-builder';

export interface Args {
  displayModal: boolean;
  closeModal: () => void;
  canCloseModal: boolean;
  modalType: ModalTypes | undefined;
  modalHeader: string;
  modalButtonLabel: string;
  modalButtonDisabled: boolean;
  modalButtonAction: () => void;
  contractedPriceEstimate: string;
  formattedAnnualTotalOnRenewal: string;
  formattedRenewalDate: string;
  isUpgrading: boolean;
  isDowngrading: boolean;
  isDowngradingToEssential: boolean;
  remainingItemsOnSubscriptionOnCancellingDowngrade: string[];
  copilotPlanName: string;
  extraLiteSeatsForDowngradePlan: number;
  selectedPlanName: string;
}
interface Signature {
  Args: Args;
  Blocks: any;
}

export default class SubscriptionBuilderModal extends Component<Signature> {
  get ModalTypes() {
    return ModalTypes;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::AnnualManageSubscription::SubscriptionBuilderModal': typeof SubscriptionBuilderModal;
    'billing/annual-manage-subscription/subscription-builder-modal': typeof SubscriptionBuilderModal;
  }
}
